



















































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { UpmindObjectMap } from "@/data/enums/objects";

// Types
import { IImportMapping, IStepMappingsProviderMethods } from "@/models/imports";

@Component({
  components: {
    "select-mapping-render": () =>
      import("@/components/app/admin/imports/selectMappingRender.vue")
  }
})
export default class SelectMappingModal extends Mixins(HasValidation) {
  // Inject

  @Inject({ from: "mappingMethods" })
  public readonly $mappingMethods!: IStepMappingsProviderMethods;

  // Props

  @Prop({ required: true })
  public mapping!: IImportMapping;

  // Data

  public isProcessing = false;
  public form: {
    objectId: string;
  } = {
    objectId: ""
  };

  // Methods

  public async submitManualObjectId() {
    try {
      this.isProcessing = true;
      // Validate form
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      // Update mapping
      await this.$mappingMethods.update(this.mapping.id, this.form.objectId);
      // Close modal
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      // Handle error
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public onSelect(value) {
    return this.$emit("onSelect", value);
  }

  // Computed

  public get mappedObjectType() {
    return UpmindObjectMap()[this.mapping.object_type];
  }

  public get showSelectMapping() {
    return !!this.mappedObjectType;
  }

  public get objectName() {
    return _.get(this.mappedObjectType, "name", this.mapping.object_type)
      .toString()
      .toLowerCase();
  }

  public get identifierName() {
    return this.mapping.external_name;
  }
}
